import {combineReducers} from 'redux'
import {AUTHENTICATED_USER_LOADED, AUTHENTICATED_USER_DISCARDED, AUTHENTICATED_USER_CONFIGS_LOADED, AUTHENTICATED_USER_CONFIGS_RESET, LOGGED_IN} from './actions'
import {AUTHENTICATED_USER_CONFIGS_UPDATED, CREDENTIAL_UPDATED, ACTIVE_USER_CMD_UPDATED, RESET_PASSWORD_DEMAND_UPDATED, RESET_PASSWORD_CMD_UPDATED, UPDATE_USER_CMD_UPDATED, RESET_LOGIN_DEMAND_UPDATED} from './actions'
import {AUTHENTICATED_USER_CONFIGS_SENT, ACTIVE_USER_CMD_SENT, RESET_PASSWORD_DEMAND_SENT, RESET_PASSWORD_CMD_SENT, UPDATE_USER_CMD_SENT, RESET_LOGIN_DEMAND_SENT} from './actions'

function authenticated(state = null, action) {
    switch(action.type) {
        case AUTHENTICATED_USER_LOADED:
            return action.user
        case AUTHENTICATED_USER_DISCARDED:
            return null
        default:
            return state
    }
}

function authenticatedConfigs(state = null, action) {
    switch(action.type) {
        case AUTHENTICATED_USER_CONFIGS_LOADED:
        case AUTHENTICATED_USER_CONFIGS_RESET:
            return action.userConfigs
        case AUTHENTICATED_USER_CONFIGS_UPDATED:
            return {...state, ...action.userConfigs}
        default:
            return state
    }
}

function credential(state = null, action) {
    switch (action.type) {
        case CREDENTIAL_UPDATED:
            return {...state, ...action.credential}
        case LOGGED_IN:
            return null
        default:
            return state
    }
}

function activeUserCmd(state = null, action) {
    switch (action.type) {
        case ACTIVE_USER_CMD_UPDATED:
            return {...state, ...action.cmd}
        case ACTIVE_USER_CMD_SENT:
            return null
        default:
            return state
    }
}

function resetPasswordDemand(state = null, action) {
    switch (action.type) {
        case RESET_PASSWORD_DEMAND_UPDATED:
            return {...state, ...action.demand}
        case RESET_PASSWORD_DEMAND_SENT:
            return null
        default:
            return state
    }
}

function resetPasswordCmd(state = null, action) {
    switch (action.type) {
        case RESET_PASSWORD_CMD_UPDATED:
            return {...state, ...action.cmd}
        case RESET_PASSWORD_CMD_SENT:
            return null
        default:
            return state
    }
}

function updateUserCmd(state = null, action) {
    switch (action.type) {
        case UPDATE_USER_CMD_UPDATED:
            return {...state, ...action.cmd}
        case UPDATE_USER_CMD_SENT:
            return null
        default:
            return state
    }
}

function resetLoginDemand(state = null, action) {
    switch (action.type) {
        case RESET_LOGIN_DEMAND_UPDATED:
            return {...state, ...action.demand}
        case RESET_LOGIN_DEMAND_SENT:
            return null
        default:
            return state
    }
}

export default combineReducers({
    authenticated,
    authenticatedConfigs,
    credential,
    activeUserCmd,
    resetPasswordDemand,
    resetPasswordCmd,
    updateUserCmd,
    resetLoginDemand
})


// WEBPACK FOOTER //
// ./lib/user/reducers.js